var _path, _path2;
var _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgLogoConvIcon = function SvgLogoConvIcon(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9211 33.8583C24.9211 33.8583 0.685793 32.9981 0.0148947 47.3268C-0.00260695 47.6943 0.294922 48.0003 0.662457 48.0003H33.1553C33.5028 48.0003 33.8379 47.9465 34.1523 47.8473L41.9625 33.8576H24.9211V33.8583Z",
    fill: "#9D1200"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8744 0.480972C34.3636 0.165294 33.7744 0 33.1748 0H0.648211C0.290398 0 0 0.290398 0 0.648211V17.0447C0 17.3234 0.178906 17.5697 0.442728 17.6592C13.1606 21.9523 24.3436 30.1457 31.1556 42.0423C32.2193 43.9001 33.1774 45.8486 34.0174 47.8866C34.3169 47.8062 34.5995 47.685 34.8588 47.5294C34.8815 47.5151 34.9042 47.5009 34.9269 47.4866C42.7741 42.6134 48 33.9176 48 24.0006C48 14.0837 42.7514 5.34774 34.8744 0.480972Z",
    fill: "#FFF6F4"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoConvIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-conv-icon.c0e2fc56.svg";
export { ForwardRef as ReactComponent };